import {use} from 'react';

import {DroppableDropContext} from '../utils/droppableDropContext';
import {DragAndDropContextType} from '../utils/types';

export const useFullDnDContext = <TDnDData>(): DragAndDropContextType<TDnDData> => {
  const ctx = use(DroppableDropContext) as DragAndDropContextType<TDnDData>;
  return ctx;
};
